import React, { useEffect, useRef, useState } from "react";
import servicosAtribuicaoExterna from "../../servicos/servicos-externos/servicos-atribuicao-externa";
import servicosColaborador from "../../servicos/servicos-colaborador";
import servicosMotivo from "../../servicos/servicos-motivo";
import MenuLateral from "./MenuLateral";
import Table from 'react-bootstrap/Table';
import NavMenu from "./Nav";
import { ToastContainer, toast } from 'react-toastify';
import Salvar from "../../img/svgs/Salvar";
import { Button } from "@mui/material";
import * as XLSX from 'xlsx';

const dadosAtribuicao = {
    "id_colaborador": 0,
    "id_motivo": 0,
    "data": new Date()
}

const AtribuicaoMilhasExterna = () => {
    const [colaboradores, setColaboradores] = useState([]);
    const [motivos, setMotivos] = useState(null);
    const [data, setData] = useState(dadosAtribuicao);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [selectedComponent, setSelectedComponent] = useState('excel');
    const [listaMilhas, setListaMilhas] = useState([]);
    const [errosAtribuicoesRealizadas, setErrosAtribuicoesRealizadas] = useState([]);
    const fileInputRef = useRef(null);

    useEffect(() => {

        let listaCargosFiltro = ['GERENTE COMERCIAL', 'GERENTE REGIONAL', 'SUPERINTENDENCIA', 'GERENTE'];
        function getDados() {
            servicosColaborador.listarTodos()
                .then(response => {
                    let listaGerentes = [];
                    let listaColaboradores = [];
                    if (response.status === 200) {
                        response.data.map(colaborador => {
                            if (listaCargosFiltro.includes(String(colaborador.Cargo[0].nome_cargo).trim()) && String(colaborador.Setor[0].nome_setor).trim() === 'COMERCIAL') {
                                return listaGerentes.push(colaborador);
                            } else {
                                return listaColaboradores.push(colaborador);
                            }
                        })

                    }
                    setColaboradores(listaGerentes);


                }).catch((error) => {
                    console.log(error);
                });
        }
        getDados();
    }, [listaFiltrada]);

    useEffect(() => {
        function getDados() {

            servicosMotivo.listarTodos()
                .then(response => {
                    if (response.status === 200) {
                        setMotivos(response.data);
                    }
                }).catch((error) => {
                    console.log(error);
                });

        }
        getDados()
    }, []);

    const handleChange = (e) => {
        let { name, value } = e.target;
        if (name === 'id_colaborador' || name === "id_motivo") {
            value = Number(value);
        }
        setData({ ...data, [name]: value });

    }


    const handlePesquisa = (e) => {
        const pesquisa = e.target.value;
        let listaAtualizada = [];
        if (pesquisa !== "") {
            listaAtualizada = colaboradores.filter((item) => {
                return String(item.nome).toLowerCase().indexOf(pesquisa.toLowerCase()) !== -1;
            })
            setListaFiltrada(listaAtualizada);
        } else {
            setListaFiltrada(colaboradores);
        }

    }

    const handleComponent = (comp) => {
        setSelectedComponent(comp)
    }

    const handleFileUpload = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);

                // Agora você pode processar os dados em jsonData
                setListaMilhas(jsonData);
            };

            reader.readAsArrayBuffer(file);
        }

    };

    const clearDados = () => {
        setErrosAtribuicoesRealizadas([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Limpa o valor do input
        }
        setListaMilhas([]);
    }

    const processarAtribuicoes = async (listaAtribuicao) => {
        return new Promise(async (resolve, reject) => {
            let listaErros = [];
            for (const iterator of listaAtribuicao) {
                let obj = {
                    "id_colaborador": iterator.id_colaborador,
                    "id_motivo": 340,
                    "data": new Date(),
                    "qtd_producao": iterator.producao
                };

                try {
                    await servicosAtribuicaoExterna.create(obj);
                } catch (error) {
                    console.log(error);
                    obj["nome"] = iterator.nome;
                    obj["producao"] = iterator.producao;
                    listaErros.push(obj)
                    reject(error);
                }
            }
            setErrosAtribuicoesRealizadas(listaErros);
            resolve(true);
        });
    };

    const atribuirViaExcel = async () => {

        const listaParaAtribuicao = colaboradores.map(colaborador => {
            for (const iterator of listaMilhas) {
                if (String(colaborador.nome).includes(String(iterator?.Gerente).substring(5))) {
                    return {
                        id_colaborador: colaborador.id_colaborador,
                        nome: colaborador.nome,
                        producao: iterator["R$ 1,000,000.00"]
                    };
                }
            }
            return null; // Se não encontrar correspondência para o colaborador
        }).filter(item => item !== null); // Remove os elementos nulos
        if (listaParaAtribuicao.length === 0) {
            toast.error('Não foi possível realizar a atribuição');
            return
        }
        await toast.promise(
            processarAtribuicoes(listaParaAtribuicao)
            , {
                pending: 'Processando',
                success: 'Atribuição realizada 👌',
                error: 'Não foi possível efetuar a atribuição 🤯'
            }
        );

        clearDados();
    }

    const SelectMotivos = () => {
        if (motivos === null) {
            return <>Carregando lista de motivos</>
        }
        return (
            <>
                <label htmlFor="id_motivo" className="form-label mb-3 me-2">Motivo</label>
                <select className="form-select w-50 mb-3 rounded-5" name="id_motivo" onChange={handleChange} aria-label="" defaultValue={data.id_motivo}>
                    <option value={0}>Selecione</option>
                    {motivos.map((item) => {
                        const id = item.id_motivo;
                        return <option key={id} value={id}>{item.descricao}</option>
                    })}
                </select>
            </>
        )
    }



    const atribuicaoMultipla = async () => {
        if (data.id_motivo > 0) {

            for await (const colaborador of colaboradores) {
                const elementoWeb = document.querySelector(`#qtd_producao${colaborador.id_colaborador}`);
                if (Number(elementoWeb?.value) !== 0 && elementoWeb?.value !== undefined) {
                    let obj = {
                        "id_colaborador": colaborador.id_colaborador,
                        "id_motivo": data?.id_motivo,
                        "data": new Date(),
                        "qtd_producao": Number(elementoWeb?.value)
                    }
                    await servicosAtribuicaoExterna.create(obj)
                        .then(response => {
                            if (response.status === 201) {
                                const elementoWeb = document.querySelector(`#qtd_producao${obj.id_colaborador}`);
                                elementoWeb.value = null;
                            }
                        })
                        .catch(e => {
                            toast.error(`Erro ao tentar atribuir milhas colaborador id ${obj.id_colaborador}  ${e.response.data.message} `);
                        })
                }
            }

            toast('Finalizado atribuição');
        } else {
            toast.error(`Por favor selecione um motivo válido `);

        }
    }
    return <>
        <NavMenu />
        <ToastContainer />

        <div className="d-flex container" >
            <div className="w-25">
                <MenuLateral />
            </div>
            <div className="">
                <div >
                    <Button onClick={() => handleComponent('excel')} color="warning" variant={selectedComponent === 'excel' ? "contained" : "outlined"} sx={{ borderRadius: 25 }}>Via Excel</Button>
                    <Button onClick={() => handleComponent('table')} color="warning" variant={selectedComponent === 'table' ? "contained" : "outlined"} sx={{ borderRadius: 25 }} style={{ marginLeft: 10 }} >Via Tabela</Button>
                </div>
                {selectedComponent === 'excel' && <div className=" h-100" >
                    <input type="file" ref={fileInputRef} accept=".xlsx" className="mt-3" onChange={handleFileUpload} />
                    <Button variant="contained" color="warning" sx={{ borderRadius: 25, marginLeft: 1 }} onClick={() => atribuirViaExcel()}>Atribuir</Button>
                    <Button variant="outlined" color="warning" sx={{ borderRadius: 25, marginLeft: 1 }} onClick={() => clearDados()}>Limpar Dados</Button>

                    {errosAtribuicoesRealizadas.length > 0 && <div className="mt-4">
                        <h3 className="text-center subtitulo" style={{ fontSize: 18 }}>Erros Atribuição</h3>

                        <Table striped bordered className="mt-4" >
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Nome</th>
                                    <th >Produção</th>
                                </tr>
                            </thead>
                            <tbody >
                                {
                                    errosAtribuicoesRealizadas.map(colaborador => (
                                        <tr key={colaborador.id_colaborador} id={colaborador.id_colaborador}>
                                            <td width={50}>{colaborador.id_colaborador}</td>
                                            <td width={180}>{colaborador.nome}</td>
                                            <td width={180}>{colaborador.producao}</td>
                                        </tr>
                                    ))

                                }
                            </tbody>
                        </Table></div>}
                </div>}
                {selectedComponent === 'table' && <div style={{ overflow: "auto", height: "70vh" }} >
                    <div className="d-flex sob-tabelas">
                        <div className="d-flex align-items-center row w-50 ms-1">
                            <SelectMotivos />
                            <span className="">Busca:</span> <input
                                className="mb-3 w-50  rounded-5"
                                type="text"
                                id="pesquisa"
                                style={{ height: 25 }}
                                onChange={handlePesquisa}
                            />
                        </div>
                        <div className="d-flex justify-content-center align-items-center w-50">

                            <h3 className="text-center subtitulo">Atribuição de Produção</h3>

                        </div>

                    </div>
                    <Table striped bordered   >
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Nome</th>
                                <th >Produção</th>
                                <th>Cargo</th>
                            </tr>
                        </thead>
                        <tbody >
                            {
                                listaFiltrada.length > 0 ? (listaFiltrada.map(colaborador => (
                                    <tr key={colaborador.id_colaborador} id={colaborador.id_colaborador}>
                                        <td width={50}>{colaborador.id_colaborador}</td>
                                        <td width={180}>{colaborador.nome}</td>
                                        <td width={50} className="text-center">
                                            <input id={`qtd_producao${colaborador.id_colaborador}`} className="rounded-5 w-50" />
                                        </td>
                                        <td width={180}>{colaborador.Cargo[0].nome_cargo}</td>
                                    </tr>
                                ))) : (colaboradores.map(colaborador => (
                                    <tr key={colaborador.id_colaborador} id={colaborador.id_colaborador}>
                                        <td width={50}>{colaborador.id_colaborador}</td>
                                        <td width={180}>{colaborador.nome}</td>
                                        <td width={50} className="text-center" >
                                            <input id={`qtd_producao${colaborador.id_colaborador}`} className="rounded-5 w-50" />
                                        </td>
                                        <td width={180}>{colaborador.Cargo[0].nome_cargo}</td>

                                    </tr>
                                )))

                            }
                        </tbody>
                    </Table>
                    <button type="button" onClick={() => atribuicaoMultipla()} className="btn-icones rounded p-1"><Salvar /> Salvar</button>

                </div>}
            </div>
        </div>
    </>
}

export default AtribuicaoMilhasExterna;